<template>
  <el-dropdown placement="bottom">
    <el-space>
      <span :style="{ color: props.color }">
        <!-- Language-{{ $t('common.name') }} -->
        Language
      </span>
      <el-icon :style="{ color: props.color }">
        <CaretBottom />
      </el-icon>
    </el-space>
    <template #dropdown>
      <el-dropdown-item @click="changeLang('zh-cn')">
        中文
      </el-dropdown-item>
      <el-dropdown-item @click="changeLang('en')">
        English
      </el-dropdown-item>
      <el-dropdown-item @click="changeLang('fr')">
        Français
      </el-dropdown-item>
    </template>
  </el-dropdown>
</template>

<script setup>
import { ref } from 'vue'
import { setLanguage } from '@/i18n'

const fullscreenLoading = ref(false)

const props = defineProps({
  color: {
    type: String,
    default: '#000'
  }
})

async function changeLang(lang) {
  fullscreenLoading.value = true
  await setLanguage(lang)
  window.location.reload(true)
}
</script>

<style lang="scss" scoped>
.ant-pro-drop-down {
  .overlayClassName {
    margin-right: 20px;
  }
}
.el-tooltip__trigger:first-child:focus-visible {
  outline: unset;
}
</style>
